module.exports = "/images/deactivated.png?43ded5c84f44a4df67b9d7a082e1d126";